import {createActions} from 'client/framework';

const normalActions = [
  'RESET_STORE',
  'SET_ACTIVE_ATTEMPT_ID',
  'SET_ATTEMPTS',
  'SET_ATTEMPTS_BY_NUMBER_TO_SHOW'
];

export const previousAttemptsActions = createActions(null, normalActions);
